import SEO from "@/components/SEO";
import Reveal from "@/components/Reveal";

const LegalPage = ({ seoTitle, seoDescription, path, title, intro, sections, testId }) => (
  <>
    <SEO
      title={seoTitle}
      description={seoDescription}
      path={path}
      breadcrumbs={[{ name: "Home", path: "/" }, { name: title, path }]}
    />
    <section className="pt-40 lg:pt-48" data-testid={testId}>
      <div className="mx-auto max-w-3xl px-6 pb-24 lg:px-12">
        <Reveal>
          <p className="text-xs font-semibold uppercase tracking-[0.28em] text-brand">Evaya Ventures</p>
          <h1 className="mt-5 font-display text-5xl leading-[1.05] tracking-tight text-ink md:text-6xl" data-testid={`${testId}-title`}>
            {title}
          </h1>
          <p className="mt-6 text-base leading-relaxed text-ink/65 md:text-lg">{intro}</p>
        </Reveal>
        <div className="mt-12 space-y-10">
          {sections.map((section, i) => (
            <Reveal key={section.heading} delay={Math.min(i * 0.05, 0.2)}>
              <h2 className="font-display text-2xl text-ink md:text-3xl">{section.heading}</h2>
              {section.body.map((para, j) => (
                <p key={j} className="mt-4 text-base leading-relaxed text-ink/65">
                  {para}
                </p>
              ))}
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  </>
);

export default LegalPage;
